import APIHandler from 'config/APIHandler';

import { useSettings } from 'hooks/useSettings';

import ContactCard from 'views/ContactView/ContactCard/ContactCard';

import { useQuery } from '@tanstack/react-query';

interface ContactEmail {
  email: string;
}

interface Contact {
  area?: string;
  country?: string;
  name?: string;
  title?: string;
  address?: string;
  avatar?: string;
  options?: unknown;
  image?: string;
  phone?: string;
  website?: string;
  other_copy?: string;
  emails?: ContactEmail[];
}

interface ContactsResponse {
  response: Contact[];
}

async function fetchContacts(id: string | number): Promise<ContactsResponse> {
  return APIHandler.getContacts(id) as Promise<ContactsResponse>;
}

export function ContactView() {
  const { salesCompanionAppId } = useSettings();

  const { data: contacts = [] } = useQuery<Contact[]>({
    queryKey: ['contacts', salesCompanionAppId],
    queryFn: async () => {
      const res = await fetchContacts(salesCompanionAppId as string | number);
      return res.response;
    },
    enabled: salesCompanionAppId != null,
  });

  return (
    <div className="contentContainer contact">
      <div className="contactView">
        {contacts.map((contact, index) => (
          <div key={index}>
            {contact.area && contacts[index - 1]?.area !== contact.area && (
              <div className="headerContact">{contact.area}</div>
            )}
            {!contact.area && contact.country && contacts[index - 1]?.country !== contact.country && (
              <div className="headerContact">{contact.country}</div>
            )}
            {contact.name && (
              <div className="contactView__Card">
                <div className="contactView__Content__Card">
                  <ContactCard
                    name={contact.name}
                    title={contact.title}
                    mail={contact}
                    imageUrl={contact.image}
                    telephone={contact.phone}
                    other={contact.other_copy}
                    town={contact.address}
                  />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
